import React, { useState } from "react";
import GlobalDialog from "../../mui/Dialogue/GlobalDialog";
import { Button } from "@mui/material";
import ViewOptionsGrid from "./ViewOptionsGrid";
import { useFormik } from "formik";
import NoDataFound from "../../NodataIndication/NoDataFound";

const ViewOptions = ({ data }) => {
  const [open, setOpen] = useState(false);
  const initialValues = {
    options: data,
  };
  const formik = useFormik({
    initialValues,
  });
  return (
    <div>
      <GlobalDialog
        title={"Course Options"}
        open={open}
        setOpen={setOpen}
        fullScreen
        // maxWidth={"xl"}
        closeButton={true}
        popupButton={<Button onClick={() => setOpen(true)}>View</Button>}
        content={
          <>
            {data?.length > 0 ? (
              <> {open ? <ViewOptionsGrid formik={formik} /> : null}</>
            ) : (
              <NoDataFound />
            )}
          </>
        }
      />
    </div>
  );
};

export default ViewOptions;
